import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=5988cd72&"
import script from "./PropertyDetail.vue?vue&type=script&lang=js&"
export * from "./PropertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports